import { getConceptCode } from "./getConceptCode";
import { getCountryCode } from "./getCountryCode";
export const locationSearchMapConfig = {    
    initView: {
        lat: getCountryCode() === 'us' ? '43' : '50',
        lng: getCountryCode() === 'us' ? '-99' : '-100',
        zoom: '4',
        mobileZoom:'2.2',
    },
    franchiseWebLocationsApiCall: `${process.env.JS_API_URL}/${process.env.JS_DigitalOrchestrations_URL}/v1/public/concepts/${getConceptCode()}/franchiseweblocations`,
    // Geocoding/reverse-geocoding now goes through google.maps.Geocoder (Search.ts) —
    // no REST URL/key needed here anymore (migrated from HERE geocode/revgeocode).
    fullAttributeApiUrl: `${process.env.JS_API_URL}/${process.env.JS_DigitalOrchestrations_URL}/v1/public/fullattribute/franchiseWeblocations/search`,
    nblyApiKey: process.env.JS_API_KEY,
    mobileViewWidth: 992,
    desktopMapContainerCol: 'map-wrapper-mobile',
    mobileMapContainerCol: 'map-wrapper'
}
// set level to 'debug' if you want to fetch data from ./franchiseWebLocations.json
export const debugConfig = {
    level: 'prod'
}
export const brandColorCode:any = {
    "MRE":"#006AC6",
    "RBW":"#18487F",
    "WDG":"#500878",
    "DVW":"#463C96",
    "SHG":"#005489",
    "HMS":"#009578",
	"LAP":"#C93F01",
	"JUK":"#ED1C24",
	"PDS":"#00523D",
	"MOJ":"#43B02A",	
	"MDG":"#0B408F",
    "MLY":"#071D49",
    "MRR":"#003DA6",
    "GUY":"#4A7729",
    "MRA":"#F4633A",
    "FSA":"#FF6900",
    "ASV":"#0033a0",
    "FSP":"#003057",
    "PLG":"#eb0045",
    "PLG2C":"#eb0045",
    "MRH":"#b52126",
    "MHM":"#b52126",
    "HMC":"#b52126",
    "NEI":"#407EC9"
}

export const nearbyLocationsExists = (): boolean => {
    const locationData: NearbyLocationData = JSON.parse(sessionStorage.getItem("nearbyLocations") ?? "null");
    return !!locationData?.containingData;
}
export interface NearbyLocationData {
    containingData: boolean;
    franchiseLimit: number;
    units: string;
    resultData: any;
    searchQuery: string;
}